import { faker } from '@faker-js/faker'

import { getUserServiceOfferOption } from './UserServiceOfferOption'

import { asBuilder } from '../asBuilder'
import { UserServiceOfferOptions } from '../../contracts/service-offer'

export const getUserServiceOfferOptions = asBuilder((): UserServiceOfferOptions => {
  return {
    available: faker.datatype.boolean(),
    options: faker.helpers.multiple(getUserServiceOfferOption),
  }
})
